import { render, staticRenderFns } from "./PostEditoCreateGoogle.vue?vue&type=template&id=af7ad79e&scoped=true&"
import script from "./PostEditoCreateGoogle.vue?vue&type=script&lang=js&"
export * from "./PostEditoCreateGoogle.vue?vue&type=script&lang=js&"
import style0 from "./PostEditoCreateGoogle.vue?vue&type=style&index=0&id=af7ad79e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7ad79e",
  null
  
)

export default component.exports